import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { mapKey } from '../../../utils/mapKey'
import { OrganizationPollsData, OrganizationPollsState } from './types'

const initialState: OrganizationPollsState = {}

const organizationPollsSlice = createSlice({
  name: 'organizationPolls',
  initialState,
  reducers: {
    setOrganizationPollsData: (
      state,
      action: PayloadAction<{ organizationId: string; data: OrganizationPollsData }>
    ) => {
      state[mapKey(action.payload.organizationId)] = action.payload.data
    },
    setOrganizationPollsError: (state, action: PayloadAction<string>) => {
      state[mapKey(action.payload)] = 'error'
    },
    setOrganizationPollsPending: (state, action: PayloadAction<string>) => {
      state[mapKey(action.payload)] = 'pending'
    },
  },
})

export const { setOrganizationPollsData, setOrganizationPollsError, setOrganizationPollsPending } =
  organizationPollsSlice.actions

export default organizationPollsSlice.reducer
